// extracted by mini-css-extract-plugin
export default {"footer_accordian":"FooterAccordian_footer_accordian__IJKgi","title":"FooterAccordian_title__VDhgw","open":"FooterAccordian_open__9wki9"};